import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import {
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
  AgrPageSidesheetModule,
  AgrNotificationEmptyModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';

import { VarietyPropertiesRoutingModule } from './variety-properties-routing.module';
import { VarietyPropertiesComponent } from './variety-properties.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [VarietyPropertiesComponent],
  imports: [
    SharedModule,
    VarietyPropertiesRoutingModule,
    MatFormFieldModule,
    MatSelectModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatListModule,
    RouterModule,
    AgrPageSidesheetModule,
    MatToolbarModule,
    AgrNotificationEmptyModule,
    AgrResponsiveActionsModule,
  ],
})
export class VarietyPropertiesModule {}
